import { styled } from '@mui/system';
import { TableCell, TableRow } from '@mui/material';

export const CustomTableDays = styled(TableRow)(() => ({
  display: 'grid',
  gridTemplateColumns: `200px repeat(7, minmax(104px, 1fr))`, // First column is wider, all columns have fixed min width to ensure alignement
  alignItems: 'center',
  padding: '8px, 6px',
}));

// Space reserved for notifications, spans 2 columns
export const NotificationPanelContainer = styled(TableCell)(() => ({
  gridColumn: '1 / 2', // Assign the first column of the table
  alignSelf: 'center',
  display: 'flex',
  gap: '4px',
  flexDirection: 'row',
  borderRadius: '10px',
  padding: '0 8px',
}));

// Styled table cell for the title section
export const ShiftsCellDays = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));
